<script setup>
import {CheckIcon} from '@heroicons/vue/solid'
import {computed} from "vue";
import {Link} from '@inertiajs/vue3';

const props = defineProps({
    step: Object,
    currentIdx: Number,
    currentStep: Number,
})

const isCurrentStep = computed(() => {
    return (props.currentIdx+1) == props.currentStep;
});

const isCompletedStep = computed(() => {
    return (props.currentIdx+1) < props.currentStep;
});

</script>
<template>
    <Link v-if="isCompletedStep" :href="step.href" class="group flex items-center w-full">
                            <span class="px-5 py-4 flex items-center font-medium">
                                <span
                                    class="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-primary-600 rounded-full group-hover:bg-primary-800">
                                    <CheckIcon class="w-6 h-6 text-white" aria-hidden="true"/>
                                </span>
                                <span class="ml-4 font-bold text-primary-500">{{ $t(step.name) }}</span>
                            </span>
    </Link>
    <Link v-else-if="isCurrentStep" :href="step.href"
          class="px-5 py-4 flex items-center font-medium" aria-current="step">
                            <span
                                class="flex-shrink-0 w-10 h-10 flex items-center justify-center border-2 border-primary-600 rounded-full bg-primary-100">
                                <span class="text-primary-600">{{ step.id }}</span>
                            </span>
        <span class="ml-4 font-medium text-primary-600">{{ $t(step.name) }}</span>
    </Link>
    <Link v-else disabled class="group flex items-center">
                            <span class="px-5 py-4 flex items-center font-medium">
                                <span
                                    class="flex-shrink-0 w-10 h-10 flex items-center justify-center border-2 border-gray-300 rounded-full group-hover:border-gray-400">
                                    <span class="text-gray-500 group-hover:text-gray-900">{{ step.id }}</span>
                                </span>
                            <span class="ml-4 font-medium text-gray-500 group-hover:text-gray-900">{{
                                    $t(step.name)
                                }}</span>
                            </span>
    </Link>
</template>